/**
 * Collection Lists Toggle
 * A simple script to handle toggling between two collections in a section
 */

// Initialize all collection toggles when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initCollectionToggles();
});

// Also initialize on Shopify section load events
document.addEventListener('shopify:section:load', (event) => {
  initCollectionToggles(event.target);
});

/**
 * Initialize all collection toggle functionality
 * @param {HTMLElement} container - Optional container to scope the initialization
 */
function initCollectionToggles(container = document) {
  // Find all toggle sections
  const toggleSections = container.querySelectorAll('.section[is="collection-lists-toggle"]');
  console.log(`Found ${toggleSections.length} toggle sections`);
  
  toggleSections.forEach((section, index) => {
    setupToggleSection(section, index);
  });
}

/**
 * Set up a single toggle section
 * @param {HTMLElement} section - The section element
 * @param {number} index - Index for debugging
 */
function setupToggleSection(section, index) {
  console.log(`Setting up toggle section ${index}`);
  
  // Find required elements
  const sectionInner = section.querySelector('.section-inner');
  if (!sectionInner) {
    console.log(`No section inner found in section ${index}`);
    return;
  }
  
  const header = sectionInner.querySelector('.section-header');
  if (!header) {
    console.log(`No header found in section ${index}`);
    return;
  }
  
  // Find toggle buttons in THIS section's header
  const toggleButtons = header.querySelectorAll('.collection-list-toggle');
  console.log(`Toggle buttons found in section ${index}:`, toggleButtons.length);
  
  if (toggleButtons.length === 0) {
    console.log(`No toggle buttons found in section ${index}`);
    return;
  }
  
  // Find collection containers
  const slidersContainer = sectionInner.querySelector('.featured-collection__sliders');
  let collections = [];
  let slider = null;
  
  if (slidersContainer) {
    // Featured collection mode
    collections = slidersContainer.querySelectorAll('[data-collection-type]');
    slider = slidersContainer.querySelector('.product-slider__container');
  } else {
    // Collection list mode
    collections = sectionInner.querySelectorAll('.collection-item');
  }
  
  if (collections.length === 0) {
    console.log(`No collections found in section ${index}`);
    return;
  }
  
  console.log(`Collection items found in section ${index}:`, collections.length);
  
  // Create and insert the pill background if it doesn't exist
  const btnGroup = header.querySelector('.btn-group');
  let pillBackground = btnGroup.querySelector('.pill-background');
  
  if (btnGroup && !pillBackground) {
    pillBackground = document.createElement('div');
    pillBackground.className = 'pill-background';
    btnGroup.appendChild(pillBackground);
  }
  
  // Set up the current state
  let currentType = 'first';
  
  // Set initial state
  showCollections(currentType);
  
  // Add click handlers to toggle buttons
  toggleButtons.forEach(button => {
    // Remove any existing event listeners to prevent duplicates
    button.removeEventListener('click', handleToggleClick);
    
    // Add new click handler
    button.addEventListener('click', handleToggleClick);
  });
  
  /**
   * Handle toggle button clicks
   * @param {Event} event - Click event
   */
  function handleToggleClick(event) {
    const button = event.currentTarget;
    console.log(`Toggle clicked in section ${index}:`, button.dataset.collectionType);
    const selectedType = button.dataset.collectionType;
    
    // Don't do anything if clicking the already active button
    if (selectedType === currentType) {
      return;
    }
    
    showCollections(selectedType);
  }
  
  /**
   * Show collections of the specified type
   * @param {string} type - Collection type ('first' or 'second')
   */
  function showCollections(type) {
    currentType = type;
    console.log(`Showing collections of type ${type} in section ${index}`);
    
    // Update button states
    toggleButtons.forEach(button => {
      const isSelected = button.dataset.collectionType === type;
      button.classList.toggle('active', isSelected);
      button.setAttribute('aria-pressed', isSelected);
    });
    
    // Update pill position
    if (pillBackground) {
      pillBackground.classList.toggle('right', type === 'second');
    }
    
    // Show/hide collections based on type
    collections.forEach(collection => {
      const collectionType = collection.dataset.collectionType;
      if (collectionType) {
        collection.style.display = collectionType === type ? '' : 'none';
      }
    });
    
    // Reset slider position and trigger resize
    if (slider) {
      slider.scrollLeft = 0;
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }
}
